import { render, staticRenderFns } from "./ZoomImage.vue?vue&type=template&id=f1a282a2&scoped=true&"
import script from "./ZoomImage.vue?vue&type=script&lang=js&"
export * from "./ZoomImage.vue?vue&type=script&lang=js&"
import style0 from "./ZoomImage.vue?vue&type=style&index=0&id=f1a282a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a282a2",
  null
  
)

export default component.exports